import React, { FC, useEffect, useMemo } from 'react';

import { UINotifier } from 'app/components/ui';
import { useMenuPeriodsData } from 'app/hooks/accessors';
import { useFurtherPeriodOrder } from 'app/views/Basket/hooks/useFurtherPeriodOrder';
import { formatFurtherPeriodDate } from 'app/views/Basket/BasketWithCustomization/components/FurtherPeriodDishes/FurtherPeriodDishes';

import { getFurtherPeriodNotifierText, TFurtherPeriodNotifierContext, TFurtherPeriodDates } from './texts';

type TProps = {
    context: TFurtherPeriodNotifierContext;
    cb: (shouldShow?: boolean) => void;
};

/**
 * @description уведомление о блюде, добавленном из блока топ-блюда
 * в следующий цикл: показывается только тем пользователям, у кого
 * две корзины (запись в sessionStorage с периодом != текущего)
 */
export const FurtherPeriodNotifier: FC<TProps> = ({ context, cb = () => {} }) => {
    const { period, shouldShow } = useFurtherPeriodOrder();
    const { periods } = useMenuPeriodsData();

    /* @note границы цикла берём из периодов меню (start/end цикла),
     * а если период уже не отдаётся (сменили регион), показываем начало */
    const dates = useMemo<TFurtherPeriodDates>(() => {
        const furtherPeriod = periods?.find(({ start }: { start: string }) => start === period);

        return {
            start: formatFurtherPeriodDate(furtherPeriod?.start || period || ''),
            end: formatFurtherPeriodDate(furtherPeriod?.end || period || ''),
        };
    }, [period, periods]);

    useEffect(() => {
        cb(shouldShow);
    }, [cb, shouldShow]);

    if (!shouldShow) return null;

    return (
        <UINotifier
            text={getFurtherPeriodNotifierText(context, dates)}
            backgroundColor={(context === 'address' || context === 'datetime')
                ? '#FFF' : undefined}
            textColor={(context === 'address' || context === 'datetime') ? '#9C9C9C' : undefined}
        />
    );
};

export default FurtherPeriodNotifier;
